export const routes: Record<string, (lang: string) => string> = {
    "preRegistration": (lang: string) => {
        switch (lang) {
            case 'it':
                return '/pre-registrazione';
            case 'en':
                return '/pre-registration';
            default:
                return '/pre-registrazione';
        }
    },
    "howReservationsWork": (lang: string) => {
        switch (lang) {
            case 'it':
                return '/come-funziona-il-sistema-di-prenotazione';
            case 'en':
                return '/how-reservations-work';
            default:
                return '/come-funziona-il-sistema-di-prenotazione';
        }
    },
};